import { Button, MessageBar } from '@ksb/ui';
import { fehlerText } from '../api/client';

export function Fehleranzeige({
  fehler,
  erneutVersuchen,
}: {
  fehler: unknown;
  /** Zeigt „Erneut versuchen“ (z. B. `refetch` einer Abfrage). */
  erneutVersuchen?: () => void;
}) {
  return (
    <MessageBar intent="error" title="Das hat nicht geklappt">
      <p style={{ margin: 0 }}>{fehlerText(fehler)}</p>
      {erneutVersuchen && (
        <Button variant="text" size="sm" onClick={erneutVersuchen}>
          Erneut versuchen
        </Button>
      )}
    </MessageBar>
  );
}
